export default {
  kameraplaner: {
    intro: {
      badge: 'Interaktives Planungstool – kostenlos & unverbindlich',
      title: 'Planen Sie Ihre Kameraanlage vorab',
      lead:
        'Mit dem SSG KameraPlaner können Sie Räume oder Flächen zeichnen, Türen, Fenster und wichtige Überwachungsbereiche markieren und mögliche Kamerapositionen testen. Sie erhalten eine erste visuelle Einschätzung, die anschließend von SSG Signaltechnik fachlich geprüft werden kann.',
      noReg: 'Ohne Registrierung',
      localSave: 'Lokal im Browser gespeichert',
      noBinding: 'Keine verbindliche Kamerazahl',
      quickTitle: 'Schnell-Check starten',
      quickDesc:
        'Beantworten Sie in fünf kurzen Schritten Fragen zu Ihrem Objekt, den gewünschten Überwachungsbereichen und Funktionen. Sie erhalten sofort eine übersichtliche Zusammenfassung.',
      quickList: {
        '0': 'Objektart & zu überwachende Bereiche',
        '1': 'Gewünschte Funktionen & Objektdaten',
        '2': 'Ergebnis zusammenfassen & direkt senden',
      },
      quickCta: 'Schnell-Check starten',
      plannerTitle: 'Grundriss selbst planen',
      plannerDesc:
        'Zeichnen Sie Räume und Wände, platzieren Sie Türen, Fenster, Hindernisse und Kameras – mit Sichtkegeln, Abdeckungsanalyse und automatischen Positionsvorschlägen.',
      plannerList: {
        '0': 'Zeichenfläche mit Raster & Meter-Skalierung',
        '1': 'Sichtkegel, Überwachungsziele & Privatzonen',
        '2': 'Grundriss-Upload, Auswertung & Druck',
      },
      plannerCta: 'Grundriss selbst planen',
      savedTitle: 'Es gibt eine gespeicherte Planung',
      savedDesc: 'Sie wurde automatisch lokal gespeichert und kann fortgesetzt werden.',
      resume: 'Letzte Planung fortsetzen',
    },
    quick: {
      steps: { '0': 'Objektart', '1': 'Bereiche', '2': 'Funktionen', '3': 'Objektdaten', '4': 'Ergebnis' },
      back: 'Zur Übersicht',
      title: 'Schnell-Check',
      subtitle: 'Fünf kurze Schritte – danach erhalten Sie eine übersichtliche Zusammenfassung Ihrer Vorplanung.',
      stepOf: 'Schritt {{current}} von {{total}}',
      objectQuestion: 'Welche Objektart passt zu Ihnen?',
      chooseOne: 'Bitte wählen Sie eine Option aus.',
      areasQuestion: 'Welche Bereiche sollen überwacht werden?',
      multiSelect: 'Mehrfachauswahl möglich.',
      featuresTitle: 'Gewünschte Funktionen',
      dataTitle: 'Objektdaten',
      dataOptional: 'Alle Angaben sind optional und können übersprungen werden.',
      areaSize: 'Ungefähre Gesamtfläche (m²)',
      roomCount: 'Anzahl Räume oder Bereiche',
      inOut: 'Innenbereich, Außenbereich oder beides?',
      inside: 'Innenbereich',
      outside: 'Außenbereich',
      both: 'Beides',
      maxDistance: 'Geschätzte größte Überwachungsentfernung',
      pleaseSelect: 'Bitte wählen',
      distanceUpTo5: 'Bis 5 Meter',
      distance5to10: '5 bis 10 Meter',
      distance10to20: '10 bis 20 Meter',
      distanceOver20: 'Über 20 Meter',
      internet: 'Internetanschluss vorhanden?',
      network: 'Netzwerkverkabelung vorhanden?',
      power: 'Strom am Montagepunkt?',
      yes: 'Ja',
      no: 'Nein',
      unknown: 'Unbekannt',
      recordingDuration: 'Gewünschte Aufzeichnungsdauer',
      installType: 'Neue Anlage oder bestehendes System?',
      newSystem: 'Neue Anlage',
      existingSystem: 'Bestehendes System',
      existingManufacturer: 'Hersteller und Modell der bestehenden Anlage (falls bekannt)',
      requirements: 'Besondere Anforderungen',
      requirementsPlaceholder: 'Zum Beispiel besondere Lichtverhältnisse, Denkmalschutz, spezielle Auflagen...',
      chars: '{{current}}/500 Zeichen',
      ssgCarePre: 'Ich interessiere mich zusätzlich für',
      ssgCarePost: '– Wartung und persönliche Betreuung der Anlage.',
      overviewTitle: 'Ihre Vorplanung im Überblick',
      amberNote:
        'Auf Grundlage Ihrer Angaben kommen mehrere Kamerapositionen beziehungsweise Kameratypen infrage. Für eine zuverlässige Empfehlung sollten Blickwinkel, Montagehöhe, Lichtverhältnisse und vorhandene Hindernisse geprüft werden.',
      planFloorplan: 'Grundriss zusätzlich planen',
      sendToSsg: 'Angaben an SSG senden',
      editResult: 'Ergebnis bearbeiten',
      backBtn: 'Zurück',
      next: 'Weiter',
      summary: {
        objectType: 'Objektart',
        areas: 'Überwachungsbereiche',
        features: 'Gewünschte Funktionen',
        areaSize: 'Ungefähre Gesamtfläche',
        roomCount: 'Räume / Bereiche',
        inOut: 'Bereich',
        maxDistance: 'Größte Überwachungsentfernung',
        internet: 'Internetanschluss',
        network: 'Netzwerkverkabelung',
        power: 'Strom am Montagepunkt',
        recordingDuration: 'Aufzeichnungsdauer',
        installType: 'Anlage',
        existingSystem: 'Vorhandene Anlage',
        requirements: 'Besondere Anforderungen',
        ssgCare: 'SSG-Care-Betreuung',
      },
      values: {
        notSpecified: 'Nicht angegeben',
        inside: 'Innenbereich',
        outside: 'Außenbereich',
        inOut: 'Innen & Außen',
        present: 'Vorhanden',
        notPresent: 'Nicht vorhanden',
        unknown: 'Unbekannt',
        unclear: 'noch unklar',
        newSystem: 'Neue Anlage',
        existing: 'Bestehendes System',
        desired: 'Gewünscht',
      },
    },
    topbar: {
      projectName: 'Projektname',
      undo: 'Rückgängig',
      undoTip: 'Rückgängig (Strg+Z)',
      redo: 'Wiederholen',
      redoTip: 'Wiederholen (Strg+Y)',
      save: 'Zwischenspeichern',
      saved: 'Gespeichert',
      saveTip: 'Zwischenspeichern',
      reset: 'Zurücksetzen',
      resetTip: 'Planer zurücksetzen',
      help: 'Hilfe',
      helpTip: 'Einführung erneut öffnen',
      evaluate: 'Planung auswerten',
      evaluateTip: 'Planung auswerten',
    },
    tools: {
      select: { label: 'Auswählen', hint: 'Elemente verschieben, Größe ändern, drehen. Leere Fläche ziehen = verschieben.' },
      erase: { label: 'Löschen', hint: 'Element durch Klick löschen.' },
      room: { label: 'Rechteckiger Raum', hint: 'Raum oder Fläche durch Ziehen zeichnen – Maße werden live angezeigt.' },
      polygon: { label: 'Freie Fläche', hint: 'Freie Fläche freihändig zeichnen: Maustaste gedrückt halten und Form aufziehen.' },
      wall: { label: 'Wand', hint: 'Wand durch Ziehen zeichnen – begrenzt Sichtlinien.' },
      door: { label: 'Tür', hint: 'Tür an einer Wand platzieren – danach direkt verschieben oder drehen.' },
      window: { label: 'Fenster', hint: 'Fenster an einer Wand platzieren – danach direkt verschieben oder drehen.' },
      obstacle: { label: 'Hindernis', hint: 'Säule, Regal, Trennwand oder Möbelblock zeichnen.' },
      watch: { label: 'Überwachungsziel', hint: 'Wichtigen Bereich markieren, der erfasst werden soll.' },
      privacy: { label: 'Privatzone', hint: 'Bereich markieren, der nicht erfasst werden soll.' },
      camera: { label: 'Kamera', hint: 'Kamera per Klick platzieren. Rechts öffnet sich das Modell-Dropdown – das zur Fläche passende Modell ist bereits empfohlen.' },
      text: { label: 'Text', hint: 'Raumnamen oder Beschriftungen ergänzen.' },
    },
    editor: {
      tools: 'Werkzeuge',
      autoSuggest: 'Automatische Vorschläge',
      analysis: 'Abdeckungsanalyse',
      properties: 'Eigenschaften',
      backToIntro: 'Zur KameraPlaner-Übersicht',
      resetTitle: 'Planer zurücksetzen?',
      resetText:
        'Alle gezeichneten Elemente, Kameras und der hochgeladene Grundriss werden dauerhaft gelöscht. Die gespeicherte Planung wird entfernt.',
      cancel: 'Abbrechen',
      confirmReset: 'Ja, zurücksetzen',
      close: 'Schließen',
      openTools: 'Werkzeuge öffnen',
      openAnalysis: 'Analyse öffnen',
      snap: 'Rasterfang ein/aus',
      zoomIn: 'Hineinzoomen',
      zoomOut: 'Herauszoomen',
      fit: 'Grundriss zentrieren',
      closeHints: 'Hinweise schließen',
    },
    canvas: {
      areaLabel: 'Grundriss-Zeichenfläche',
      calibHint: 'Bitte Strecke für Skalierung festlegen',
      locked: 'gesperrt',
      scale: 'Skalierung: ca. {{px}} px/m · Raster {{step}} m',
      calibNotice: 'Klicken Sie zwei Punkte auf dem Grundriss, deren Abstand Sie kennen.',
    },
    props: {
      edit: 'Eigenschaften bearbeiten',
      delete: 'Löschen',
      cameraModel: 'Kameramodell (echtes Gerät)',
      nameNumber: 'Name / Nummer',
      cameraCategory: 'Kamerakategorie',
      modelAssigned: 'Modell „{{series}}“ ist zugewiesen.',
      planningValues: 'Dies sind Planungswerte – keine technischen Daten eines realen Produkts.',
      visibility: 'Sichtweite',
      recognition: 'Erkennung',
      detail: 'Detail',
      rotation: 'Ausrichtung (°)',
      fov: 'Sichtwinkel (°)',
      range: 'Reichweite (m)',
      posX: 'Position X (m)',
      posY: 'Position Y (m)',
      mountHeight: 'Montagehöhe (m)',
      indoor: 'Innen',
      outdoor: 'Außen',
      usage: 'Einsatzbereich',
      dayNight: 'Tag / Nacht',
      target: 'Gewünschtes Überwachungsziel',
      noneAssigned: 'Keines zugewiesen',
      targetArea: 'Zielbereich',
      remark: 'Bemerkung',
      remarkPlaceholder: 'z. B. Hinweise zu Montage oder Umgebung...',
      coneNote:
        'Der Sichtkegel ist eine Planungsdarstellung. Die tatsächliche Bildqualität hängt von Modell, Objektiv, Entfernung, Montagehöhe, Licht und Hindernissen vor Ort ab.',
      roomLabel: 'Raumbezeichnung',
      length: 'Länge (m)',
      width: 'Breite (m)',
      area: 'Fläche: ca. {{area}} m²',
      designation: 'Bezeichnung',
      points: '{{count}} Punkte – Punkte direkt auf der Zeichenfläche verschieben.',
      wallThickness: 'Wandstärke (m)',
      wallLength: 'Länge: ca. {{length}} m',
      wallNote: 'Massiv eingezeichnete Wände begrenzen Sichtlinien im Planer.',
      obstacleKind: 'Art des Hindernisses',
      shape: 'Form',
      rect: 'Rechteck',
      circle: 'Kreis',
      caption: 'Beschriftung',
      diameter: 'Durchmesser (m)',
      depth: 'Tiefe (m)',
      goalKind: 'Art des Ziels',
      priority: 'Priorität',
      goal: 'Gewünschtes Ziel',
      coverageNote: 'Die Abdeckung wird farblich bewertet (grün / gelb / rot). Für Detailziele gelten strengere Anforderungen.',
      zoneKind: 'Art der Zone',
      privacyNote: 'Überschneidet ein Sichtkegel diese Zone, erscheint eine Warnung in der Analyse.',
      textContent: 'Textinhalt',
      duplicate: 'Duplizieren',
      deleteElement: 'Element löschen',
      projectData: 'Projektdaten',
      noElement: 'Kein Element ausgewählt',
      projectName: 'Projektname',
      objectType: 'Objektart',
      objectTypePlaceholder: 'z. B. Einfamilienhaus',
      projectDescription: 'Projektbeschreibung',
      projectDescriptionPlaceholder: 'Besonderheiten, Wünsche oder Rahmenbedingungen...',
      maxChars: 'Maximal 500 Zeichen',
      cameraForNew: 'Kameramodell für neue Kameras',
      cameraForNewDesc:
        'Wählen Sie unten das gewünschte Safire-Modell aus – das Dropdown öffnet sich automatisch. Neue Kameras werden mit diesen Einstellungen platziert.',
      recommendedFor: 'Empfohlen für Ihre Fläche:',
      orGeneric: 'oder generische Kategorie',
      tips: 'Tipps',
      tip1: 'Mit dem Auswahl-Werkzeug Leerfläche ziehen = Arbeitsfläche verschieben. Mausrad = Zoom.',
      tip2: 'Strg+Z = Rückgängig, Strg+Y = Wiederholen, Entf = Element löschen.',
      tip3: 'Rasterfang lässt sich in den Ansichtsoptionen ein- und ausschalten.',
      suggestPositions: 'Kamerapositionen automatisch vorschlagen',
      doorSwing: 'Öffnungsrichtung',
      left: 'Links',
      right: 'Rechts',
      none: 'Keine',
      attached:
        'An einer Wand platziert – zum Verschieben entlang der Wand ziehen. Beim Drehen wird das Element freigestellt.',
      detached: 'Freistehend platziert – frei verschieben und drehen.',
      doorNote: 'Material, Verglasung und Öffnungszustand müssen vor Ort geprüft werden.',
    },
    result: {
      edit: 'Planung bearbeiten',
      print: 'Zusammenfassung drucken',
      savePdf: 'Als PDF speichern',
      send: 'Planung an SSG senden',
      eyebrow: 'Auswertung',
      title: 'Ihre Vorplanung im Überblick',
      disclaimer:
        'Diese Auswertung ist eine unverbindliche Vorplanung. Eine endgültige Empfehlung erfolgt erst nach Prüfung der örtlichen Gegebenheiten und Auswahl der konkreten Kameratechnik.',
      project: 'Projekt',
      objectType: 'Objektart:',
      uploadPresent: 'Grundriss-Upload vorhanden:',
      scaled: 'skaliert',
      refDistance: 'm Referenzstrecke',
      notScaled: 'noch nicht skaliert',
      createdAt: 'Erstellt am',
      floorplan: 'Gezeichneter Grundriss',
      noElements: 'Noch keine Elemente im Grundriss vorhanden.',
      stats: {
        rooms: 'Räume & Flächen',
        walls: 'Wände',
        doors: 'Türen',
        windows: 'Fenster',
        obstacles: 'Hindernisse',
        cameras: 'Kameras',
        zones: 'Zielbereiche',
        privacy: 'Privatzonen',
      },
      zonesTitle: 'Überwachungsziele und Prioritäten',
      noZones: 'Keine Überwachungsziele markiert.',
      priorityLabel: 'Priorität',
      goalLabel: 'Ziel',
      goalOverview: 'Übersicht',
      goalDetail: 'Detail',
      goalObservation: 'Beobachtung',
      coverage: 'geometrische Abdeckung',
      camerasTitle: 'Kamerapositionen und Kameratypen',
      noCameras: 'Noch keine Kameras platziert.',
      modelLabel: 'Modell',
      fovLabel: 'Sichtwinkel',
      visibilityLabel: 'Sichtweite ca.',
      recognitionLabel: 'Erkennung ca.',
      detailLabel: 'Detail ca.',
      positionLabel: 'Position',
      rotationLabel: 'Ausrichtung',
      rangeLabel: 'Reichweite ca.',
      mountLabel: 'Montagehöhe',
      indoor: 'Innen',
      outdoor: 'Außen',
      day: 'Tag',
      night: 'Nacht',
      dayNight: 'Tag & Nacht',
      target: 'Ziel',
      assigned: 'Zugewiesen',
      modelNote:
        'Gewählte Safire-Modelle basieren auf Datenblattwerten; Sichtweite/Erkennung/Detail sind berechnete Planungswerte (EN 62676-4). Ohne Modell sind die Werte generische Planungswerte – keine technischen Daten eines realen Produkts.',
      blindTitle: 'Mögliche tote Winkel und offene Punkte',
      uncovered: 'Nicht ausreichend abgedeckte Bereiche:',
      privacyOverlaps: 'Überschneidungen mit Privatzonen:',
      checkPrivacy: 'Position, Ausrichtung oder Maskierung prüfen.',
      missingTitle: 'Fehlende wichtige Angaben',
      quickTitle: 'Gewünschte Funktionen und Objektdaten',
      areasLabel: 'Bereiche:',
      featuresLabel: 'Funktionen:',
      areaLabel: 'Fläche:',
      recordingLabel: 'Aufzeichnung:',
      internetLabel: 'Internet:',
      powerLabel: 'Strom:',
      careInterest: 'Interesse an SSG-Care-Betreuung',
      finalNote:
        'Die Planung wird von SSG Signaltechnik fachlich geprüft. Montagehöhe, Lichtverhältnisse, Blickwinkel und die Gegebenheiten vor Ort entscheiden über die endgültige Ausführung.',
      sendBottom: 'Planung an SSG Signaltechnik senden',
      consult: 'Persönliche Beratung anfragen',
      good: 'Gut abgedeckt',
      partial: 'Teilweise abgedeckt',
      insufficient: 'Nicht ausreichend',
    },
    send: {
      back: 'Zurück',
      title: 'Planung an SSG Signaltechnik senden',
      lead:
        'Ihre Planerdaten (Grundriss, Kameras, Sichtwinkel, Überwachungsziele, Privatzonen und Analyseergebnis) werden zusammen mit Ihren Kontaktdaten übermittelt. Erst jetzt werden Kontaktdaten benötigt – die Planung selbst bleibt lokal auf Ihrem Gerät.',
      dataTitle: 'Übermittelte Planerdaten',
      floorplan: 'Grundriss',
      rooms: 'Räume/Flächen',
      walls: 'Wände',
      doors: 'Türen',
      windows: 'Fenster',
      obstacles: 'Hindernisse',
      cameras: 'Kameras',
      none: 'keine',
      zones: 'Überwachungsziele',
      privacy: 'Privatzonen',
      analysis: 'Analyse',
      good: 'gut',
      partial: 'teilweise',
      insufficient: 'nicht ausreichend abgedeckt',
      upload: 'Grundriss-Upload',
      scaled: 'skaliert',
      notScaled: 'nicht skaliert',
      customerType: 'Privat- oder Gewerbekunde *',
      privateCustomer: 'Privatkunde',
      businessCustomer: 'Gewerbekunde',
      name: 'Vor- und Nachname *',
      company: 'Unternehmen (optional)',
      phone: 'Telefonnummer',
      email: 'E-Mail-Adresse *',
      projectAddress: 'Projektadresse',
      projectAddressPlaceholder: 'Straße, PLZ, Ort',
      contactPref: 'Bevorzugte Kontaktart',
      any: 'Egal',
      byPhone: 'Telefon',
      byEmail: 'E-Mail',
      callbackTime: 'Bevorzugter Rückrufzeitraum',
      noCallback: 'Kein Rückruf gewünscht',
      morning: 'Vormittag',
      afternoon: 'Nachmittag',
      evening: 'Abend',
      systemStatus: 'Neue oder bestehende Anlage',
      newSystem: 'Neue Anlage',
      existingSystem: 'Bestehende Anlage',
      unsure: 'Noch unsicher',
      existingManufacturer: 'Hersteller einer vorhandenen Anlage (falls bekannt)',
      existingManufacturerPlaceholder: 'z. B. Hikvision, Safire...',
      careInterest: 'Interesse an SSG Care',
      careYes: 'Ja, bitte informieren',
      careNo: 'Nein',
      careLater: 'Später entscheiden',
      message: 'Zusätzliche Nachricht',
      messagePlaceholder: 'Ergänzungen zu Ihrer Planung...',
      fileUpload: 'Grundriss / Fotos (optional)',
      fileNote: 'Hinweis: Datei-Uploads werden als „Uncollectable“ behandelt – die Planungsdaten werden als Text übermittelt.',
      privacyConsent:
        'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung dieser Anfrage zu. Die Planungsdaten werden ausschließlich für die Bearbeitung verwendet. *',
      privacyLink: 'Datenschutzerklärung',
      error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
      networkError: 'Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      successTitle: 'Vielen Dank für Ihre Planung.',
      successText: 'SSG Signaltechnik prüft Ihre Angaben und meldet sich persönlich bei Ihnen.',
      sending: 'Wird gesendet...',
      submit: 'Planung an SSG senden',
      backToResult: 'Zurück zur Auswertung',
    },
    tour: {
      stepOf: 'Schritt {{current}} von {{total}}',
      skip: 'Überspringen',
      back: 'Zurück',
      next: 'Weiter',
      finish: 'Los geht’s',
      dialogLabel: 'Einführung KameraPlaner',
      steps: {
        '0': { title: 'Willkommen beim SSG KameraPlaner', text: 'Zeichnen Sie Ihren Raum oder laden Sie einen Grundriss hoch.' },
        '1': { title: 'Bereiche markieren', text: 'Markieren Sie Türen, Fenster und wichtige Bereiche.' },
        '2': { title: 'Kameras platzieren', text: 'Platzieren Sie Kameras oder lassen Sie sich Positionen vorschlagen.' },
        '3': { title: 'Sichtfelder prüfen', text: 'Prüfen Sie Sichtfelder und mögliche tote Winkel.' },
        '4': { title: 'Planung senden', text: 'Senden Sie die Vorplanung an SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'Abdeckungsanalyse',
      suggest: 'Positionen vorschlagen',
      suggestTip: 'Kamerapositionen vorschlagen',
      cameras: 'Kameras',
      zones: 'Zielbereiche',
      good: 'Gut abgedeckt',
      partial: 'Teilweise',
      notCovered: 'Nicht abgedeckt',
      privacyConflict: 'Privatzone-Konflikt',
      areaCoverage: 'Geometrische Flächenabdeckung',
      areaNote: 'Geometrisch dargestellte Abdeckung – keine Aussage über tatsächliche Bild- oder Erkennungsqualität.',
      legend: 'Legende',
      legendFov: 'Kamerasichtfeld',
      legendDetail: 'Scharfe Detail-Erkennung (gestrichelt)',
      legendGood: 'Ziel gut abgedeckt',
      legendPartial: 'Ziel teilweise abgedeckt',
      legendBad: 'Ziel nicht ausreichend',
      legendPrivacy: 'Privatzone / ausgeschlossen',
      note: 'Die Farbbewertung ist eine geometrische Orientierung. Ein breiter Sichtwinkel bedeutet nicht automatisch ausreichende Detailerkennung – Entfernung, Auflösung und Montagehöhe müssen geprüft werden.',
    },
    upload: {
      title: 'Grundriss hochladen',
      desc: 'Optional: Laden Sie einen vorhandenen Grundriss (JPG, PNG oder WebP) als Hintergrund. Anschließend markieren Sie eine bekannte Strecke und geben deren Länge ein, damit der Planer korrekt skaliert.',
      choose: 'Grundriss auswählen',
      chooseOther: 'Anderes Bild wählen',
      remove: 'Entfernen',
      calibPrompt: 'Klicken Sie jetzt Punkt A und Punkt B auf dem Grundriss in der Zeichenfläche.',
      startCalib: 'Skalierung starten',
      scaled: 'Skaliert: {{cm}} cm pro Pixel · Strecke {{m}} m',
      lengthPlaceholder: 'Länge in Metern',
      apply: 'Anwenden',
      opacity: 'Deckkraft {{pct}} %',
      lock: 'Hintergrund sperren (verhindert versehentliches Verschieben)',
      moveHint: 'Verschieben: mit dem Auswahl-Werkzeug eine leere Stelle auf dem Bild ziehen (falls nicht gesperrt).',
      privacyNote: 'Grundrisse und Objektfotos können sensible Informationen enthalten. Laden Sie nur Dateien hoch, die für die Bearbeitung Ihrer Anfrage erforderlich sind.',
      onlyImages: 'Bitte nur Bilder im Format JPG, PNG oder WebP auswählen.',
      tooLarge: 'Die Datei ist zu groß. Bitte ein Bild unter 8 MB auswählen.',
      readError: 'Die Datei konnte nicht gelesen werden.',
      validLength: 'Bitte geben Sie eine gültige Länge in Metern ein.',
      tooClose: 'Die markierten Punkte liegen zu dicht beieinander.',
    },
    picker: {
      generic: 'Generische Kategorie wählen',
      genericOption: 'Generische Kategorie (ohne Modell)',
      recommended: 'Empfohlen',
      recommendation: 'Empfehlung für Ihre Fläche',
      fovLabel: 'Sichtwinkel',
      detailFrom: 'Detail ab ca. {{detail}} m · Erkennung ca. {{recognition}} m',
      hFov: 'Sichtwinkel horizontal',
      vFov: 'Sichtwinkel vertikal',
      resolution: 'Auflösung',
      lens: 'Objektiv',
      irRange: 'IR-Reichweite',
      ipClass: 'Schutzklasse',
      audio: 'Audio',
      dayNight: 'Tag / Nacht',
      datenblatt: 'Datenblatt',
      planungswert: 'Planungswert',
      doriNote:
        'Sichtweite/Erkennung/Detail: berechnete Planungswerte nach EN 62676-4 (Pixel-Dichte). Die tatsächliche Bildqualität hängt von Modell, Objektiv, Montagehöhe, Licht und Hindernissen vor Ort ab.',
      groups: {
        standard: 'Standard / Innen & Außen',
        outdoor: 'Außenbereich',
        panorama180: 'Panorama',
        ptz: 'Schwenk / Zoom',
      },
    },
    quickswitch: {
      title: 'Kamera-Modell ändern',
      subtitle: 'Variante direkt wechseln',
      active: 'Aktiv',
      recommended: 'Empfohlen',
      note: 'Ausrichtung, Reichweite und Montagehöhe stellen Sie im rechten Eigenschaften-Panel ein.',
      close: 'Modellauswahl schließen',
    },
    elementTypes: {
      room: 'Raum / Fläche',
      polygon: 'Freie Fläche',
      wall: 'Wand',
      door: 'Tür',
      window: 'Fenster',
      obstacle: 'Hindernis',
      watchzone: 'Überwachungsziel',
      privacy: 'Privatzone / Ausnahme',
      camera: 'Kamera',
      text: 'Text',
    },
    defaults: { room: 'Raum', watchzone: 'Zielbereich', text: 'Raumname' },
    defaultProject: 'Meine Kameraplanung',
    quickProject: 'Kameraplanung (Schnell-Check)',
  },
};